<template>
  <el-input
    v-bind="$attrs"
    :icon="value.toString().length ? closeIcon : $attrs.icon"
    :value="value"
    @input="e => $emit('input', e)"
    :on-icon-click="clearValue"
    v-on="$listeners">
     <slot v-for="name in Object.keys(this.$slots)"  :name="name" :slot="name"></slot>
  </el-input>
</template>

<script>
export default {
  name: 'QnInput',
  props: {
    clearable: {
      type: Boolean,
      default: true
    },
    value: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    closeIcon() {
      return this.clearable ? 'close': ''
    }
  },
  methods: {
    clearValue() {
      if (!this.clearable) return
      this.$emit('input', '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QnInput/index.vue?deefa300